import { FC } from 'react';

export const Camera: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.0704 5C9.73601 5 9.42378 5.1671 9.23832 5.4453L8.12892 7.1094C7.75799 7.6658 7.13352 8 6.46482 8H5C4.44772 8 4 8.44772 4 9V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V9C20 8.44771 19.5523 8 19 8H17.5352C16.8665 8 16.242 7.6658 15.8711 7.1094L14.7617 5.4453C14.5762 5.1671 14.264 5 13.9296 5H10.0704ZM7.57422 4.3359C8.13061 3.5013 9.06731 3 10.0704 3H13.9296C14.9327 3 15.8694 3.5013 16.4258 4.3359L17.5352 6L19 6C20.6569 6 22 7.34315 22 9V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V9C2 7.34315 3.34315 6 5 6H6.46482L7.57422 4.3359ZM12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11ZM8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13Z"
			fill="currentColor"
		/>
	</svg>
);
